"use client";
import React, { useCallback } from "react";
import classnames from "classnames";
interface IProps {}
export const clickToReviewsId = "clickToReviewsId";
const PriceClient: React.FC<React.PropsWithChildren<IProps>> = (props) => {
    const goToReviews = useCallback(() => {
        let reviews: any = document.getElementById(clickToReviewsId);
        reviews?.scrollIntoView({ behavior: "smooth" });
    }, []);
    return (
        <div className={classnames("default_layout")} onClick={goToReviews}>
            {props.children}
        </div>
    );
};

export default PriceClient;
